import React, { useEffect, useState } from 'react';
import { Card, Button, Badge, Input, Toggle, Modal, ConfirmDialog, EmptyState } from '../components/ui';
import { automationAPI, accountsAPI, projectsAPI, productsAPI } from '../api/client';
import toast from 'react-hot-toast';

const DAYS = [
  { v: 0, l: 'Lun' }, { v: 1, l: 'Mar' }, { v: 2, l: 'Mié' }, { v: 3, l: 'Jue' },
  { v: 4, l: 'Vie' }, { v: 5, l: 'Sáb' }, { v: 6, l: 'Dom' },
];

const TONES = ['profesional', 'casual', 'inspiracional', 'humoristico'];

const EMPTY_FORM = { name: '', project_id: null, product_id: null, account_ids: [], tone: 'profesional', days_of_week: [], time_of_day: '09:00', is_active: true, auto_publish: false, image_mode: 'libre' };

function RuleForm({ initial, accounts, projects, products, onSave, onCancel, loading }) {
  const [form, setForm] = useState(initial || EMPTY_FORM);
  const set = (key) => (val) => setForm(f => ({ ...f, [key]: val }));
  const toggleDay = (d) => setForm(f => ({
    ...f,
    days_of_week: f.days_of_week.includes(d) ? f.days_of_week.filter(x => x !== d) : [...f.days_of_week, d],
  }));
  const toggleAccount = (id) => setForm(f => ({
    ...f,
    account_ids: f.account_ids.includes(id) ? f.account_ids.filter(x => x !== id) : [...f.account_ids, id],
  }));

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (!form.name || form.account_ids.length === 0 || form.days_of_week.length === 0) {
          toast.error('Nombre, al menos una cuenta y al menos un día son requeridos');
          return;
        }
        onSave(form);
      }}
      style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
    >
      <Input label="Nombre de la regla" value={form.name} onChange={set('name')} placeholder="Ej: Posts semanales Instagram" required />

      <div>
        <label style={{ fontSize: '13px', fontWeight: '600', color: 'var(--text-secondary)', display: 'block', marginBottom: '8px' }}>Producto (recomendado)</label>
        <select
          value={form.product_id || ''}
          onChange={(e) => set('product_id')(e.target.value || null)}
          style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid var(--border)', background: 'var(--bg-elevated)', color: 'var(--text-primary)' }}
        >
          <option value="">Sin producto especifico</option>
          {products.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
        </select>
        <p style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '6px' }}>
          Si seleccionas un producto, la IA usara su descripcion, precio, caracteristicas y pitch de venta para escribir el copy.
        </p>
      </div>

      <div>
        <label style={{ fontSize: '13px', fontWeight: '600', color: 'var(--text-secondary)', display: 'block', marginBottom: '8px' }}>Proyecto (opcional)</label>
        <select
          value={form.project_id || ''}
          onChange={(e) => set('project_id')(e.target.value || null)}
          style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid var(--border)', background: 'var(--bg-elevated)', color: 'var(--text-primary)' }}
        >
          <option value="">Sin proyecto</option>
          {projects.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
        </select>
      </div>

      <div>
        <label style={{ fontSize: '13px', fontWeight: '600', color: 'var(--text-secondary)', display: 'block', marginBottom: '8px' }}>Cuentas / redes destino</label>
        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
          {accounts.map(a => (
            <button
              type="button" key={a.id} onClick={() => toggleAccount(a.id)}
              style={{
                padding: '6px 12px', borderRadius: '8px',
                border: `1px solid ${form.account_ids.includes(a.id) ? '#7c3aed' : 'var(--border)'}`,
                background: form.account_ids.includes(a.id) ? '#7c3aed20' : 'var(--bg-elevated)',
                color: form.account_ids.includes(a.id) ? '#a78bfa' : 'var(--text-muted)',
                fontSize: '12px', cursor: 'pointer',
              }}
            >{a.network} · {a.username || a.name}</button>
          ))}
        </div>
      </div>

      <div>
        <label style={{ fontSize: '13px', fontWeight: '600', color: 'var(--text-secondary)', display: 'block', marginBottom: '8px' }}>Tono</label>
        <select
          value={form.tone} onChange={(e) => set('tone')(e.target.value)}
          style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid var(--border)', background: 'var(--bg-elevated)', color: 'var(--text-primary)' }}
        >
          {TONES.map(t => <option key={t} value={t}>{t}</option>)}
        </select>
      </div>

      <div>
        <label style={{ fontSize: '13px', fontWeight: '600', color: 'var(--text-secondary)', display: 'block', marginBottom: '8px' }}>Días de ejecución</label>
        <div style={{ display: 'flex', gap: '6px' }}>
          {DAYS.map(d => (
            <button
              type="button" key={d.v} onClick={() => toggleDay(d.v)}
              style={{
                width: '44px', padding: '8px 0', borderRadius: '8px',
                border: `1px solid ${form.days_of_week.includes(d.v) ? '#7c3aed' : 'var(--border)'}`,
                background: form.days_of_week.includes(d.v) ? '#7c3aed20' : 'var(--bg-elevated)',
                color: form.days_of_week.includes(d.v) ? '#a78bfa' : 'var(--text-muted)',
                fontSize: '12px', cursor: 'pointer',
              }}
            >{d.l}</button>
          ))}
        </div>
      </div>

      <Input label="Hora de ejecución (Colombia)" type="time" value={form.time_of_day} onChange={set('time_of_day')} required />

      <Toggle checked={form.is_active} onChange={set('is_active')} label="Regla activa" />

      <div>
        <label style={{ fontSize: '13px', fontWeight: '600', color: 'var(--text-secondary)', display: 'block', marginBottom: '8px' }}>Modo de imagen</label>
        <select
          value={form.image_mode} onChange={(e) => set('image_mode')(e.target.value)}
          style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid var(--border)', background: 'var(--bg-elevated)', color: 'var(--text-primary)' }}
        >
          <option value="libre">Libre (foto/ilustración generada por IA)</option>
          <option value="plantilla">Plantilla (logo + titular + características + WhatsApp)</option>
        </select>
      </div>

      <div style={{ padding: '12px', borderRadius: '10px', background: 'var(--bg-elevated)', border: '1px solid var(--border)' }}>
        <Toggle checked={form.auto_publish} onChange={set('auto_publish')} label="Publicación automática (sin revisión humana)" />
        <p style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '8px', marginBottom: 0 }}>
          {form.auto_publish
            ? '⚡ El contenido se generará y publicará solo, sin pasar por revisión.'
            : '🔎 El contenido quedará en "Pendientes de revisión" para que lo apruebes antes de publicar.'}
        </p>
      </div>

      <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', paddingTop: '8px' }}>
        <Button type="button" variant="ghost" onClick={onCancel}>Cancelar</Button>
        <Button type="submit" loading={loading}>{initial ? 'Guardar cambios' : 'Crear regla'}</Button>
      </div>
    </form>
  );
}

function PendingCard({ p, onZoom, onReject, onPublishNow, onSchedule }) {
  const [scheduling, setScheduling] = useState(false);
  const [when, setWhen] = useState('');

  return (
    <Card style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
      {p.media_url && (
        <img src={p.media_url} alt="" onClick={() => onZoom(p.media_url)} style={{ width: '90px', height: '90px', objectFit: 'cover', borderRadius: '8px', cursor: 'zoom-in' }} />
      )}
      <div style={{ flex: 1, minWidth: '200px' }}>
        {p.networks.map(n => (
          <div key={n.id} style={{ marginBottom: '6px' }}>
            <Badge color="#7c3aed">{n.network}</Badge>
            <div style={{ fontSize: '13px', color: 'var(--text-secondary)', marginTop: '4px' }}>{n.caption}</div>
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'flex-end' }}>
        <div style={{ display: 'flex', gap: '8px' }}>
          <Button variant="ghost" onClick={() => onReject(p.id)}>Rechazar</Button>
          <Button variant="secondary" onClick={() => setScheduling(s => !s)}>Programar</Button>
          <Button onClick={() => onPublishNow(p.id)}>Publicar ahora</Button>
        </div>
        {scheduling && (
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <input
              type="datetime-local" value={when} onChange={(e) => setWhen(e.target.value)}
              style={{ padding: '8px', borderRadius: '8px', border: '1px solid var(--border)', background: 'var(--bg-elevated)', color: 'var(--text-primary)', fontSize: '13px' }}
            />
            <Button
              size="sm"
              onClick={() => {
                if (!when) { toast.error('Selecciona fecha y hora'); return; }
                onSchedule(p.id, when);
                setScheduling(false);
              }}
            >Confirmar</Button>
          </div>
        )}
      </div>
    </Card>
  );
}

export default function AutomationPage() {
  const [rules, setRules] = useState([]);
  const [pending, setPending] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [projects, setProjects] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [deleting, setDeleting] = useState(null);
  const [zoomImage, setZoomImage] = useState(null);

  const load = async () => {
    const [r, p, a, pr, prod] = await Promise.all([
      automationAPI.listRules(), automationAPI.pendingReview(),
      accountsAPI.list(), projectsAPI.list(), productsAPI.list().catch(() => ({ data: [] })),
    ]);
    setRules(r.data); setPending(p.data); setAccounts(a.data); setProjects(pr.data); setProducts(prod.data);
  };

  useEffect(() => { load(); }, []);

  const handleSave = async (form) => {
    setLoading(true);
    try {
      if (editing) await automationAPI.updateRule(editing.id, form);
      else await automationAPI.createRule(form);
      toast.success('Regla guardada');
      setShowForm(false); setEditing(null);
      await load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Error guardando la regla');
    } finally { setLoading(false); }
  };

  const handleDelete = async () => {
    try {
      await automationAPI.deleteRule(deleting.id);
      toast.success('Regla eliminada');
      setDeleting(null);
      await load();
    } catch { toast.error('No se pudo eliminar'); }
  };

  const handlePublishNow = async (id) => {
    try {
      await automationAPI.approve(id, { mode: 'now' });
      toast.success('Publicando ahora — puede tardar hasta 1 minuto');
      await load();
    } catch { toast.error('No se pudo publicar'); }
  };

  const handleSchedule = async (id, whenLocal) => {
    try {
      const iso = new Date(whenLocal).toISOString();
      await automationAPI.approve(id, { mode: 'schedule', scheduled_at: iso });
      toast.success('Programado en el Calendario');
      await load();
    } catch { toast.error('No se pudo programar'); }
  };

  const handleReject = async (id) => {
    try { await automationAPI.reject(id); toast.success('Post rechazado'); await load(); }
    catch { toast.error('No se pudo rechazar'); }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 style={{ margin: 0 }}>Automatización de marketing</h2>
        <Button icon="+" onClick={() => { setEditing(null); setShowForm(true); }}>Nueva regla</Button>
      </div>

      {pending.length > 0 && (
        <div>
          <h3 style={{ fontSize: '15px', marginBottom: '10px' }}>Pendientes de revisión ({pending.length})</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {pending.map(p => (
              <PendingCard
                key={p.id} p={p} onZoom={setZoomImage}
                onReject={handleReject} onPublishNow={handlePublishNow} onSchedule={handleSchedule}
              />
            ))}
          </div>
        </div>
      )}

      <div>
        <h3 style={{ fontSize: '15px', marginBottom: '10px' }}>Reglas configuradas</h3>
        {rules.length === 0 ? (
          <EmptyState icon="⚙" title="Sin reglas todavía" description="Crea una regla para generar contenido automáticamente" />
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {rules.map(r => (
              <Card key={r.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ fontWeight: '600' }}>
                    {r.name}{' '}
                    <Badge color={r.is_active ? '#22c55e' : '#6b7280'}>{r.is_active ? 'Activa' : 'Inactiva'}</Badge>{' '}
                    {r.auto_publish && <Badge color="#f59e0b">⚡ Auto-publica</Badge>}
                  </div>
                  <div style={{ fontSize: '13px', color: 'var(--text-secondary)', marginTop: '4px' }}>
                    {DAYS.filter(d => r.days_of_week.includes(d.v)).map(d => d.l).join(', ')} · {r.time_of_day} · {r.tone}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <Button variant="ghost" onClick={() => { setEditing(r); setShowForm(true); }}>Editar</Button>
                  <Button variant="ghost" onClick={() => setDeleting(r)}>Eliminar</Button>
                </div>
              </Card>
            ))}
          </div>
        )}
      </div>

      <Modal open={showForm} onClose={() => { setShowForm(false); setEditing(null); }} title={editing ? 'Editar regla' : 'Nueva regla de automatización'}>
        <RuleForm initial={editing} accounts={accounts} projects={projects} products={products} onSave={handleSave} onCancel={() => { setShowForm(false); setEditing(null); }} loading={loading} />
      </Modal>

      <Modal open={!!zoomImage} onClose={() => setZoomImage(null)} title="Vista previa" width={640}>
        {zoomImage && <img src={zoomImage} alt="" style={{ width: '100%', borderRadius: '12px' }} />}
      </Modal>

      <ConfirmDialog
        open={!!deleting} onClose={() => setDeleting(null)} onConfirm={handleDelete}
        title="Eliminar regla" message={`¿Eliminar la regla "${deleting?.name}"? Esta acción no se puede deshacer.`}
        confirmLabel="Eliminar" danger
      />
    </div>
  );
}
